import { MessageBar, Text, Stack } from '@fluentui/react';
import React from 'react';
import { IExpandableMessageBodyProps, MESSAGE_CONTAINER_STYLES, MESSAGE_CONTENT_STYLES, MESSAGE_PREVIEW_TEXT_STYLES, STACK_DEFAULT_PROPS, MESSAGE_TOGGLE_LINK_STYLES } from './MergeControl';

export const ExpandableMessageBody: React.FC<IExpandableMessageBodyProps> = ({ messageBarType, summary, children }) => {
    const [isExpanded, setIsExpanded] = React.useState(false);
    const hasDetails = React.Children.count(children) > 0;
    const detailsAnimationStyles: React.CSSProperties = {
        overflow: 'hidden',
        maxHeight: isExpanded ? 260 : 0,
        opacity: isExpanded ? 1 : 0,
        transform: isExpanded ? 'translateY(0)' : 'translateY(-2px)',
        transition: 'max-height 180ms ease, opacity 180ms ease, transform 180ms ease',
    };

    return (
        <MessageBar messageBarType={messageBarType}>
            <div style={MESSAGE_CONTAINER_STYLES}>
                <div style={MESSAGE_CONTENT_STYLES}>
                    <div>
                        <Text styles={MESSAGE_PREVIEW_TEXT_STYLES}>
                            {summary}
                        </Text>
                    </div>
                    {hasDetails && (
                        <div style={detailsAnimationStyles} aria-hidden={!isExpanded}>
                            <Stack {...STACK_DEFAULT_PROPS}>
                                {children}
                            </Stack>
                        </div>
                    )}
                </div>

                {hasDetails && (
                    <button
                        type='button'
                        style={MESSAGE_TOGGLE_LINK_STYLES}
                        aria-expanded={isExpanded}
                        aria-label={isExpanded ? 'Collapse message details' : 'Expand message details'}
                        title={isExpanded ? '▲ Less Information' : '▼ Show More Information'}
                        onClick={() => setIsExpanded((current) => !current)}
                    >
                        {isExpanded ? '▲ Less Information' : '▼ Show More Information'}
                    </button>
                )}
            </div>
        </MessageBar>
    );
};
